import { type FC } from 'react'

import { useTranslation } from 'react-i18next'

import style from './_message-processing.module.scss'

interface Props {
    recieved: boolean
    portrait?: boolean
}

const MessageProcessing: FC<Props> = ({ recieved, portrait = false }) => {
    const { t } = useTranslation()
    return (
        <div
            className={`${style.container_outer} ${
                recieved ? style.container_outer_recieved : ''
            } ${
                portrait ? style.container_outer_portrait : ''
            }`}
        >
            <div className={`${style.container}`}>
                <div className={style.background}></div>
                <div className={style.container_inner}>
                    <div className={style.loader_container}>
                        <div className={style.loader}></div>
                    </div>
                    <div className={style.text}>
                        {/* {t('loading')} */}
                        {t('yourMediaIsCurrentlyProsessing')}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MessageProcessing
